import {SuccessList} from "@portal/api/responses/api-response";
import {map} from "rxjs";
import { Injectable } from '@angular/core';
import { ApiBaseService } from '@portal/api/api-base-service';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse, ListResponse } from '@portal/api/responses/api-response';
import { Guid } from 'guid-typescript';
import { RoadmapAddRequest } from '@portal/api/requests/roadmap/roadmap-add-request';
import { RoadmapUpdateRequest } from '@portal/api/requests/roadmap/roadmap-update-request';
import { SearchRequest } from '@portal/api/requests/search-request';
import { RoadmapListResponse } from '@portal/api/responses/roadmap/roadmap-list-response';
import { RoadmapPreviewSection } from '@portal/api/responses/roadmap/roadmap-preview-section';
import {CollaboratorResponse} from "@portal/api/responses/collaborators/collaborator-response";
import {StorageService} from "@portal/shared/services/storage.service";
import {OrganizationType} from "@portal/api/enums/organization-type";

@Injectable({
    providedIn: 'root'
})

export class PartyRoadmapService extends ApiBaseService {
    controller = 'v1/roadmap';

    constructor(
        public http: HttpClient,
        private _storageService: StorageService) {
        super(http);
    }

    add(obj: RoadmapAddRequest): Observable<ApiResponse<Guid>> {
        const orgId = this.getOrgId();
        if (this.isOrgScope()) {
            return this.post<ApiResponse<Guid>, RoadmapAddRequest>(obj, `v1/orgs/${orgId}/roadmap/add`);
        }
        return this.post<ApiResponse<Guid>, RoadmapAddRequest>(obj, this.controller + '/add');
    }

    update(obj: RoadmapUpdateRequest): Observable<ApiResponse<Guid>> {
        const orgId = this.getOrgId();
        if (this.isOrgScope()) {
            return this.put<ApiResponse<Guid>, RoadmapUpdateRequest>(obj, `v1/orgs/${orgId}/roadmap/update`);
        }
        return this.put<ApiResponse<Guid>, RoadmapUpdateRequest>(obj, this.controller + '/update');
    }

    getFormEdit(partyNoteId: Guid): Observable<ApiResponse<RoadmapUpdateRequest>> {
        const orgId = this.getOrgId();
        if (this.isOrgScope()) {
            return this.get<ApiResponse<RoadmapUpdateRequest>>(`v1/orgs/${orgId}/roadmap/form/edit/${partyNoteId}`);
        }
        return this.get<ApiResponse<RoadmapUpdateRequest>>(this.controller + `/form/edit/${partyNoteId}`);
    }

    listByOrigin(obj: SearchRequest, originId: Guid, origin: string): Observable<ApiResponse<ListResponse<RoadmapListResponse[]>>> {
        const orgId = this.getOrgId();
        if (this.isOrgScope()) {
            return this.post<ApiResponse<ListResponse<RoadmapListResponse[]>>, SearchRequest>(
                obj,
                `v1/orgs/${orgId}/roadmap/listallbyorigin?originId=${originId}&origin=${origin}`
            );
        }
        return this.post<ApiResponse<ListResponse<RoadmapListResponse[]>>, SearchRequest>(obj, this.controller + `/ListAllByOrigin?originId=${originId}&origin=${origin}`);
    }

    previewByOrigin(originId: Guid, origin: string): Observable<ApiResponse<RoadmapPreviewSection[]>> {
        return this.get<ApiResponse<RoadmapPreviewSection[]>>(this.controller + `/PreviewByOrigin?originId=${originId}&origin=${origin}`);
    }

    deleteRoadmap(id: Guid): Observable<ApiResponse<boolean>> {
        const orgId = this.getOrgId();
        if (this.isOrgScope()) {
            return this.deleteBase<ApiResponse<boolean>>(`v1/orgs/${orgId}/roadmap/${id}`);
        }
        return this.deleteBase<ApiResponse<boolean>>(`${this.controller}/${id}`);
    }

    downloadPdf(id: Guid, collaborator: string, isEvents: boolean): Observable<HttpResponse<Blob>> {
        let origin = isEvents ? 'partyevents' : '';
        return this.getFile(this.controller + `/download-pdf?originId=${id}&collaborator=${collaborator}&origin=${origin}`);
    }

    getCollaborators() : Observable<CollaboratorResponse[]> {
        const orgId = this.getOrgId();
        if (this.isOrgScope()) {
            return this.get<SuccessList<CollaboratorResponse>>(`v1/orgs/${orgId}/collaborators/dropdown`).pipe(map((response) => response.data));
        }
        const partyId = this._storageService.getParty()?.id;
        return this.get<SuccessList<CollaboratorResponse>>(`v1/orgs/${orgId}/parties/${partyId}/collaborators/dropdown`).pipe(map((response) => response.data));
    }

    private getOrgId(): Guid {
        return this._storageService.getOrg()?.id;
    }

    private isOrgScope(): boolean {
        return this._storageService.getOrg()?.type === OrganizationType.Association;
    }
}
